/**
 * Accordion — frontend behaviour (view.js).
 *
 * @package Vertaview
 */

import { bootAccordions } from './accordion-view';

bootAccordions();
